export const ErrorTypes = {
  /* Network */
  NETWORK: 'NETWORK',
  LOGIN_REQUIRED: 'LOGIN_REQUIRED',
  FORBIDDEN: 'FORBIDDEN',
  INTERNAL: 'INTERNAL',

  /* Logical */
  INVALID_ARGS: 'INVALID_ARGS',
  NO_DATA: 'NO_DATA',

  /* Unknown */
  UNKNOWN: 'UNKNOWN'
} as const

export type ErrorType = keyof typeof ErrorTypes

export default class ErrorResponse<Meta = unknown> extends Error {
  constructor(
    public type: ErrorType,
    public originatingError?: Error,
    public meta?: Meta,
    public httpStatus?: number
  ) { super() }
}
